"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rescheduleAppointment = exports.getRescheduleReasons = void 0;
const getRescheduleReasons = '@service/GET_RESCHEDULE_REASON';
exports.getRescheduleReasons = getRescheduleReasons;
const rescheduleAppointment = '@service/RESCHEDULE_APPOINTMENT';
exports.rescheduleAppointment = rescheduleAppointment;
/**
 * Function to adapt reschedule appointment request
 *
 * @param appointment {Appointment} - Current appointment
 * @param selectedRescheduleReason {RescheduleReason | null} - Selected reschedule reason
 * @returns
 */
const rescheduleAppointmentRequestAdapter = (appointment, selectedRescheduleReason, selectedSlot) => {
    const CHANNEL = 'pmc';
    return {
        cancel: {
            channel: CHANNEL,
            appointment_ehr_id: (appointment === null || appointment === void 0 ? void 0 : appointment.appointment_ehr_id) || '',
            patient_ids: [
                {
                    pid: (appointment === null || appointment === void 0 ? void 0 : appointment.patient_ehr_id) || '',
                    source_system: (appointment === null || appointment === void 0 ? void 0 : appointment.source_system) || ''
                }
            ],
            provider_ehr_id: (appointment === null || appointment === void 0 ? void 0 : appointment.provider.provider_ehr_id) || '',
            source_system: (appointment === null || appointment === void 0 ? void 0 : appointment.source_system) || '',
            reason_code: (selectedRescheduleReason === null || selectedRescheduleReason === void 0 ? void 0 : selectedRescheduleReason.code) || '',
            reason_text: (selectedRescheduleReason === null || selectedRescheduleReason === void 0 ? void 0 : selectedRescheduleReason.text) || ''
        },
        create: {
            channel: CHANNEL,
            appointment_ehr_id: (appointment === null || appointment === void 0 ? void 0 : appointment.appointment_ehr_id) || '',
            appointment_kyruus_id: (appointment === null || appointment === void 0 ? void 0 : appointment.id) || '',
            patient_ids: [
                {
                    pid: (appointment === null || appointment === void 0 ? void 0 : appointment.patient_ehr_id) || '',
                    source_system: (appointment === null || appointment === void 0 ? void 0 : appointment.source_system) || ''
                }
            ],
            slot: selectedSlot
        }
    };
};
exports.default = {
    // Fetches reschedule reasons
    [getRescheduleReasons]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { services, appointment } = context;
        if (!services.getRescheduleReasons) {
            throw new Error('Method not implemeted!');
        }
        const response = yield services.getRescheduleReasons(appointment.source_system);
        return response.data.result;
    }),
    // Reschedules current appointment
    [rescheduleAppointment]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { services, appointment, selectedRescheduleReason, selectedSlot } = context;
        if (!services.rescheduleAppointment) {
            throw new Error('Method not implemeted!');
        }
        const requestContext = rescheduleAppointmentRequestAdapter(appointment, selectedRescheduleReason, selectedSlot);
        const response = yield services.rescheduleAppointment(requestContext);
        return response;
    })
};
//# sourceMappingURL=services.reasonMachine.js.map